var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mt-32 text-xs text-gray-600"},[_vm._v("Built with VueJS and Tailwind. Hosted on Zeit Now")])}
var staticRenderFns = []

export { render, staticRenderFns }